import { ErrorBoundary } from '@/pages/directory/directory.error';

export default ErrorBoundary;
